import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { action } from 'src/app/interfaces/action';
import { columnsDef } from 'src/app/interfaces/columnsDef';

@Component({
    selector: 'produto-insert-edit-form',
    templateUrl: './produto-insert-edit-form.component.html',
    styleUrls: ['./produto-insert-edit-form.component.scss'],
    standalone: false
})
export class ProdutoInsertEditFormComponent implements OnInit {

  constructor(private formBuilder:UntypedFormBuilder,
              @Inject(MAT_DIALOG_DATA) public dialogData,
              public dialogRef: MatDialogRef<any>,) { }

  formGroup:UntypedFormGroup;
  evento:string;
  row = {}
  parentRow={};
  actionList:action[] = [];
  tableInformation:columnsDef[] =[];
  userConfig:Object={};
  ngOnInit(): void {
      
      this.evento = this.dialogData['evento'];
      this.tableInformation = this.dialogData['tableInformation'];
      this.userConfig = this.dialogData['userConfig'];
      this.formGroup = this.formBuilder.group({});
      if ( this.evento != 'inserindo'){
        this.row = this.dialogData['row'];
      }

  }

}
